import { render } from "./FilePicker.vue?vue&type=template&id=46478c20&scoped=true"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"

import "./FilePicker.vue?vue&type=style&index=0&id=46478c20&scoped=true&lang=scss"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46478c20"]])

export default __exports__